import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    stats: {},
    filingsByYear: [],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  },
  getters: {
    filingsByMonth (state) {
      let filings = state.filingsByYear;

      let count = {
        online: {},
        paper: {},
        totals: {
          online: 0,
          paper: 0,
          all: 0,
        },
      };

      filings.forEach(filing => {

        let date = filing.completedDate.split("-");
        let monthNumber = parseInt(date[1]);
        let monthLabel = state.months[monthNumber - 1];
        let type = 'online';

        if (filing.filedOffline === 'Y') {
          type = 'paper';
        }

        if (!count[type].hasOwnProperty(monthLabel)) {
          count[type][monthLabel] = 1;
        } else {
          count[type][monthLabel]++;
        }

        count.totals[type]++;
        count.totals['all']++;

      });

      let results = {
        rows: [],
        totals: count.totals,
      };

      state.months.forEach(month => {
        results['rows'].push({
          month: month,
          online: count['online'][month] || 0,
          paper: count['paper'][month] || 0,
          total: (parseInt(count['online'][month]) || 0) + (parseInt(count['paper'][month]) || 0),
        });
      });
      return results;

    },
  },
  mutations: {
    setStats (state, stats) {
      Vue.set(state, 'stats', stats);
    },
    setFilersStatus(state, data) {
      Vue.set(state, 'filersStatus', data);
    },
    setFilingsByYear(state, data) {
      Vue.set(state, 'filingsByYear', data);
    },
  },
  actions: {
    fetchStats({ commit, rootState }, year) {
      return new Promise((resolve, reject) => {
        return this.$axios({
          method: 'get',
          url: `${rootState.endpoints.admin.reports.stats}`,
          params: {
            years: [ year ],
          },
        }).then(response => {
          commit('setStats', response.data);
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    fetchFilersStatus({ rootState }, query) {
      return new Promise((resolve, reject) => {
        return this.$axios({
          method: 'get',
          url: `${rootState.endpoints.admin.reports.filersStatus}`,
          params: query,
        }).then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
      });
    },
    filingsByYear({ rootState, commit }, year) {
      return new Promise((resolve, reject) => {
        return this.$axios({
          method: 'get',
          url: `${rootState.endpoints.admin.reports.filingsByYear}/${year}`,
        }).then(response => {
          commit('setFilingsByYear', response.data);
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
  },
};
